import TreeSelect from './treeSelect';

export default TreeSelect;
